import CrossSell from '@/components/CrossSell/CrossSell'
import TripActivity from '@/components/TripActivity/TripActivity'
import { Box } from 'pcln-design-system'
import GroupedTrip from './GroupedTrip'
import type { TripGrouping as TripGroupingProps } from './types'

export default function TripGrouping({
  tripGroupingBooking,
  tripGroupingAbandonedSelection,
  defaultAbandonedSelection,
  isLandingPage,
  growthLoopAudiences,
}: TripGroupingProps) {
  const tripActivityProductType = ['STAY', 'FLY', 'DRIVE'] as const
  if (tripGroupingBooking) {
    if (tripGroupingAbandonedSelection) {
      return (
        <>
          <Box mb={4}>
            <GroupedTrip
              isLandingPage={isLandingPage}
              booking={tripGroupingBooking}
              abandonedSelection={tripGroupingAbandonedSelection}
            />
          </Box>
          <TripActivity
            productType={tripActivityProductType}
            pageName='homepage'
            shouldUseSmallerHeading
            abandonedSelectionData={defaultAbandonedSelection}
            hideAbandonedSelection
          />
        </>
      )
    }
    return (
      <>
        <Box mb={4}>
          <CrossSell booking={tripGroupingBooking} growthLoopAudiences={growthLoopAudiences} />
        </Box>
        <TripActivity
          productType={tripActivityProductType}
          pageName='homepage'
          shouldUseSmallerHeading
          abandonedSelectionData={defaultAbandonedSelection}
          hideAbandonedSelection={false}
        />
      </>
    )
  }

  return (
    <TripActivity
      productType={tripActivityProductType}
      pageName='homepage'
      shouldUseSmallerHeading={false}
      abandonedSelectionData={defaultAbandonedSelection}
      hideAbandonedSelection={Boolean(tripGroupingAbandonedSelection)}
    />
  )
}
